<template>
  <div v-if="hasConfig && hasSchedule && !loading" class="alert alert-danger">
    <p>
      <i class="fa fa-info-circle"></i>
      <strong>Autoprovisioning Active:</strong> This domain has autoprovisioning configured using 
      <strong>{{ formatRosterService(rosterService) }}</strong>.
      1) Do not send a spreadsheet for user updates. 2) Do not manually set up or edit accounts for this domain.
    </p>
  </div>
  <div v-else-if="hasConfig && !hasSchedule && !loading" class="alert alert-warning">
    <p>
      <i class="fa fa-info-circle"></i>
      <strong>Autoprovisioning Setup Incomplete:</strong> This domain may need manual spreadsheets for now but will transition to automated provisioning in the future. See User Provisioning tab in Salesforce for more details.
    </p>
  </div>
</template>

<script>
import { ROSTER_SERVICE_NAMES } from './constants'

export default {
  name: 'AutoprovisioningAlert',
  props: {
    domainUuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      hasConfig: false,
      hasSchedule: false,
      config: null,
      error: null
    }
  },
  computed: {
    rosterService() {
      return this.config?.lambda_input?.roster_service || '';
    }
  },
  methods: {
    fetchConfig() {
      this.loading = true
      this.$angularWorld.adminApi.getAutoprovisioningConfig(this.domainUuid)
        .then(config => {
          this.config = config
          this.hasConfig = !!config
          this.hasSchedule = !!config?.schedule_arn
          this.loading = false
        })
        .catch(error => {
          console.error('Error fetching autoprovisioning config:', error)
          this.error = error
          this.loading = false
          this.hasConfig = false
          this.hasSchedule = false
          this.config = null
        })
    },
    formatRosterService(service) {
      if (!service) return 'N/A'
      return ROSTER_SERVICE_NAMES[service] || service
    }
  },
  mounted() {
    if (this.domainUuid) {
      this.fetchConfig()
    }
  },
  watch: {
    async domainUuid() {
      this.fetchConfig()
    }
  }
}
</script>

<style scoped>
.alert {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>